import type { Period } from '@weft/types';
import dayjs from 'dayjs';
import React from 'react';

type LightInvoiceStatementHeaderProps = {
  invoiceId: string;
  billingCycle: Period;
  accountName: string;
};

export const LightInvoiceStatementHeader:React.FC<LightInvoiceStatementHeaderProps> = ({
  invoiceId,
  accountName,
  billingCycle,
}) => {
  const invoiceMonth = dayjs(billingCycle.startTime).format('MMMM');
  const isAu10tix = accountName === 'Au10tix';

  return (
    <div className='pt-2'>
      <div className='border-line flex items-start justify-start gap-x-6 border-b pb-2'>
        {isAu10tix ? (
          <img
            className='w-24'
            src="/assets/images/aut10ix-logo.webp"
            alt={`${accountName} logo`}
          />
        ) : (
          <img
            className='w-24'
            src="/assets/images/Earth.webp"
            alt="default logo"
          />
        )}
        <div className='my-2'>
          <h2 className='text-xl font-medium'>{accountName}</h2>
          <h3 className='invisible text-[#6D6D6D]'>address, street name, zip code</h3>
        </div>
      </div>
      <div className='border-line border-b pb-6 text-3xl font-medium'>
        {`${invoiceMonth} report `}
        <span className='text-offwhite text-sm font-normal uppercase'>{`#${getFormattedId(invoiceId)}`}</span>
      </div>

    </div>
  );
};

const getFormattedId = (id: string, charCount = 5) => {
  const digits = -Math.abs(charCount);

  return id.slice(digits);
};